import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'cuentaunicasir/ciudadanos-administrador/';

/**
 * GET Ciudadanos
 * @returns {Promise<Array<object>>}
 */
export const getCiudadanos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Ciudadano
 * @param {number} cuentaUnicaID ID cuenta única
 * @returns {Promise<Array<Object>>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getCiudadano = async (cuentaUnicaID) => {
  try {
    const response = await API.get(`${baseURI}${cuentaUnicaID}/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Ciudadano
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCiudadano = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Ciudadano
 * @param {number} id
 * @param {object} values
 * @param {string|Node} message
 * @returns {Promise<object|boolean>}
 */
export const patchCiudadano = async (id, values, message = 'Editado correctamente') => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, message);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Ciudadano
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCiudadano = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
